<div class="image-container" [style.min-height]="minHeight()">
    <div [style.height]="height()" [style.width]="width()" [ngClass]="isLoading ? loadingContainerClass() : ''"
        style="position: relative;">
        <div *loading="isLoading;class:loadingClass()"></div>
        <img [ngClass]="[customClass(), 'image-component']" [style.opacity]="isLoading ? '0' : '1'" #image alt="image"
            [src]="computedSource.hasValue() ? computedSource.value() : null" [style.height]="isLoading ? '0px' : height()"
            [style.width]="computedSource.isLoading() ? '0px' : width()" />
    </div>
</div>
